import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Location} from '@angular/common';
import {LocalStorageManager} from 'src/app/data/manager/local-storage/local-storage.manager';
import {countryConfig} from 'src/country-config/country-config';
import {globalEnv} from 'src/app/data/networking/connection/global/global.env';
import {map} from 'rxjs/internal/operators/map';
import { from } from 'rxjs';
import { AlgoliaManager } from 'src/app/data/manager/algolia/algolia.manager';
import { SUPPORT_OPTIONS } from './support_categories';

const BASE_URL = 'https://us-central1-stunning-base-164402.cloudfunctions.net/zendeskv3/v2';
const BASE_URL2 = !countryConfig.getService 
  ? 'https://prod-dot-zendesk-dot-stunning-base-164402.uc.r.appspot.com/backend/flexible/v2/zendesk'
  : 'https://zendesk-dot-oracle-services-vzla.uc.r.appspot.com/backend/flexible/v2/zendesk';

const TRACKING_URL = !countryConfig.getService
  ? `${globalEnv.monitor}searchOrders20`
  : 'https://monitor30-reports-dot-oracle-services-vzla.uc.r.appspot.com/backend/flexible/v2/monitor/searchOrders20';

const monitor30 = {
  col: globalEnv.monitor,
  ven: 'https://monitor30-reports-dot-oracle-services-vzla.uc.r.appspot.com/backend/flexible/v2/monitor/'
}

const apiKey = 'd968d6ef-2691-490a-ad83-21eed8903b56';
const idApiKey = 'ahZzfm9yYWNsZS1zZXJ2aWNlcy12emxhcmELEgdQcm9qZWN0IiQ2YWMxMGU3Yy1hZGJkLTQyZDQtOWRmNi1i'
  + 'NWQ3YjhmNTQ1NDcMCxIGQXBpS2V5IiQ5YjgyNDJkZS03NGU0LTQzNWItYjA5Zi00MzVkYjlkYTA4MDAM';
const IMG_URL_TOKEN = `https://images-dot-oracle-services-vzla.appspot.com/_ah/api/blobEndpoint/v1/blobattributes/${idApiKey}/${apiKey}`;

const url = {
  tickets: `${BASE_URL}/tickets`,
  showTickes: `${BASE_URL}/tickets/:id`,
  addComments: `${BASE_URL}/tickets/:id/add-comments`,
  showComments: `${BASE_URL}/tickets/:id/comments`,
  orderTicketCreate: `${BASE_URL2}/insertOrderTicketZendesk`,
  orderTicketShow: `${BASE_URL2}/getOrderTicketZendeskByTicket/:id`,
  orderTicketlist: `${BASE_URL2}/getOrderTicketZendeskByUser/:id`,
  tracking: TRACKING_URL,
};
const idClient = 1984;
const baseHeader = {headers: {'Content-Type': 'application/json', 'country': countryConfig.indicator }};

@Injectable({
  providedIn: 'root',
})

export class ZendeskSupportService {
    currentUser: any = undefined;
    device = 'web';
    get support_options() { return SUPPORT_OPTIONS; }
    
    getSupportOptions(ndx: number) { 
      const op = SUPPORT_OPTIONS.find((p:any) => p.ndx === ndx);
      return op ? {...op} : null;
    }

    set cuser(nuser: any) { this.currentUser = nuser; }
    get cuser() { return this.currentUser ? this.currentUser : this.lms.get('customer'); }

    constructor(
      private http: HttpClient,
      private location: Location,
      private lms: LocalStorageManager,
      private algoliaManager: AlgoliaManager,

    ) {}

    getNow() { return new Date(); }

    getTicket(tickectID: string) {
      const vurl = url.showTickes.replace(':id', tickectID);
      return this.http.get(vurl, this.httpOptions()).toPromise();
    }
    getTicketComments() {
      const vurl = url.showTickes.replace(':id', '1855');
      return this.http.get(vurl, this.httpOptions());
    }
    getTracking(idOrder: any) {
      const body = {employeeNumber: idClient, orders: [{orderId: idOrder}]};
      return this.http.post(url.tracking, body, baseHeader).pipe(
        map((res: any) => res.data[0]),
      );
    }

    getComments(tickectID: string) {
      const vurl = url.showComments.replace(':id', tickectID);
      return this.http.get(vurl, this.httpOptions()).toPromise()
        .then((results: any) => results.comments);
    }

    getNanyTickets(tickets: string[]) {
      const serialized = tickets.join(',');
      const vurl = `${url.tickets}/show_many?ids=${serialized}`;
      return this.http.get(vurl, this.httpOptions()).toPromise();
    }

    createComments(tickectID: string, vcomment: string) {
      const vurl = url.addComments.replace(':id', tickectID);
      return this.http.post(vurl, {comment: vcomment, user: this.cuser}, this.httpOptions())
        .toPromise()
        .then((results: any) => results.comments);
    }

    getTheorical(orderId: string) {
      const base = countryConfig.getService ? monitor30.ven : monitor30.col;
      const url = `${base}getOrderDetailTheoretical`;
      return this.http.post(url, {orderId}, this.httpOptions())
        .pipe(map((m:any) => m.data))
        .toPromise();
    }

    getListBank() {
      return from(this.algoliaManager.getBankList().then(banksData => banksData.banks));
    }

    createTicket(subject: string, comment: string, params: any) {
      const asistencia = params.asistencia || '';
      const detalle = params.detalle ? params.detalle : '';
      const data: any = {subject, comment, custom_fields: []};

      const matrix = countryConfig.matrix;
      data.user = this.cuser;
      data.ticket_form_id = countryConfig.zendeskId;
      data.custom_fields.push({id: 360033314052, value: this.cuser.phone});
      data.custom_fields.push({id: 360033314012, value: this.cuser.documentNumber});
      data.custom_fields.push({id: 360034481171, value: matrix});
      data.custom_fields.push({id: 360033104771, value: params.order.idOrder});
      data.custom_fields.push({id: 360034503372, value: detalle});
      data.custom_fields.push({id: 360031848351, value: asistencia});
      data.custom_fields.push({id: 360036212271, value: this.device});
      data.custom_fields.push({id: 9343604039451, value: params.isPrime});
      data.custom_fields.push({id: 360036276472, value: 'EXPRESS'});
      data.custom_fields.push({id: 12594039699355, value: params.order.storeName});
      data.custom_fields.push({id: 12594095748123, value: params.order.paymentType.name});
      return this.http.post(`${url.tickets}/create`, data, this.httpOptions()).toPromise()
        .then((results: any) => {
          const ticket = results._ticket;
          const {idOrder} = params.order;
          const options = {
            ticket,
            incident: params.incident,
            image: params.image,
            userId: this.cuser ? this.cuser.id : '',
          };
          return this.linkTicket(idOrder, options);
        }).catch(() => Promise.reject(new Error(null)));
    }

    getNotifications() {
      const vurl = url.orderTicketlist.replace(':id', this.cuser.id);
      return this.http.get(vurl, this.httpOptions()).toPromise().then((results: any) => results.data.map((obj: any) => {
        const tmp = obj;
        tmp.incident = JSON.parse(obj.json);
        return tmp;
      }));
    }

    listTickets(uid: any = null) {
      const id = uid || this.cuser.id;
      const vurl = url.orderTicketlist.replace(':id', id);
      return this.http.get(vurl, this.httpOptions()).toPromise().then((results: any) => results.data.map((obj: any) => {
        const tmp = obj;
        tmp.incident = JSON.parse(obj.json);
        return tmp;
      }));
    }

    linkTicket(idOrder: string, params: any) {
      const body = {
        statusId: 0,
        tmp: 'n/a',
        orderId: idOrder,
        ticketId: params.ticket.id,
        userId: this.cuser ? this.cuser.id : '',
        image: params.image ? params.image : '',
        json: JSON.stringify(params.incident),
      };
      return this.http.post(url.orderTicketCreate, body, baseHeader).toPromise()
        .then(() => Promise.resolve(params.ticket));
    }

    linkTicketShow(ticket: string) {
      return this.http.get(url.orderTicketShow.replace(':id', ticket), baseHeader).toPromise().then((results: any) => {
        const data: any = (results.data?.[0]) ? results.data[0] : null;
        data.incident = JSON.parse(data.json);
        return Promise.resolve(data);
      });
    }

    uploadImage(tfile: File): Promise<any> {
      return this.http.get(IMG_URL_TOKEN).toPromise().then((results: any) => {
        const {blobURL} = results;
        return new Promise((resolve, reject) => {
          const formData = new FormData();
          const request = new XMLHttpRequest();
          formData.append('apiKey', apiKey);
          formData.append('idApiKey', idApiKey);
          formData.append('photo', tfile, tfile.name);
          request.onreadystatechange = () => {
            if (request.readyState === 4) {
              if (request.status === 201 || request.status === 200) {
                resolve(JSON.parse(request.response));
              } else {
                reject(JSON.parse(request.response));
              }
            }
          };
          request.open('POST', blobURL, true);
          request.send(formData);
        });
      });
    }

    goBack() {
      this.location.back();
    }

    private getTicketBody(subject: string, data: string) {
      return {ticket: {subject , comment: data}};
    }

    protected httpOptions(sendToken: boolean = true): {headers: HttpHeaders} {
      const params: any = {};
      const token = 'Basic eW9hbmEuYW5nYXJpdGFAZmFybWF0b2RvLmNvbS90b2tlbjp6UWZ3Y3RmNmxNQW5sbFlBSWFhMUJMRzdOYnlhVUliSlk2cVppRHA5';
      params['Content-Type'] = 'application/json';
      params['Country'] = countryConfig.indicator;
      if (sendToken) { params.Authorization = `${token}`; }
      return {headers: new HttpHeaders(params)};
    }
}

export const SCANANDGO_OPTIONS = [
  {
    ndx: 1,
    icon: '/assets/svg/support/option-01.svg',
    name: 'Dudas con el cobro',
    desc: 'Aquí encuentras la factura de tu pedido, si tienes alguna duda escríbenos para poder ayudarte.',
    invoice: {src: '/assets/svg/support/invoice.jpg'},
    widgets: [
      {
        wtype: 'list',
        title: 'Tipo de incidente',
        options: [
          {
            id: 1,
            cat: 'dudas_con_el_cobro_doble_cobro',
            uid: 'dobles_cobros',
            desc: 'Doble Cobro',
          },
          {
            id: 2,
            cat: 'dudas_con_el_cobro_doble_cobro',
            uid: 'cobrado_en_línea_y_no_entregado',
            desc: 'Cobrado en línea y no entregado',
          },
          {
            id: 3,
            cat: 'dudas_con_el_cobro_doble_cobro',
            uid: 'error_en_facturación',
            desc: 'Error de facturación',
          },
        ],
        checked: null,
      },
      {
        wtype: 'textblock',
        title: 'Escríbenos tus comentarios:',
        comment: '',
      },
    ],
    callback: 'doubleCobro',
  },
  {
    ndx: 3,
    icon: '/assets/svg/support/option-03.svg',
    name: 'Producto está en mal estado',
    file: null,
    uid: 'producto_llegó_en_mal_estado',
    desc: 'Selecciona el producto que está en mal estado y escríbenos para poder ayudarte.',
    widgets: [
      {
        wtype: 'products-list',
        products: [],
        values: null,
      },
      {
        wtype: 'textblock',
        title: 'Escríbenos tus comentarios:',
      },
      {
        wtype: 'image-unload',
        title: 'Adjuntar imagen del producto:',
        source: '',
      },
    ],
    callback: 'malEstado',
  },
  {
    ndx: 6,
    icon: '/assets/svg/support/option-06.svg',
    name: 'No se aplicó la promoción o el cupón',
    desc: 'Escribe el código del cupón o cuéntanos cuál fue la promoción que no se aplicó para poder ayudarte.',
    uid: 'no_se_aplico_promoción_o_cupón',
    widgets: [
      {
        wtype: 'textfield',
        name: 'cupon',
        value: '',
        title: 'Código del cupón:',
        placeholder: 'Escribe aquí el código',
      },
      {
        wtype: 'textblock',
        title: 'Escríbenos tus comentarios:',
      },
    ],
    callback: 'cuponPromo',
  },
];
